import environment from '../../common/environment';
import { BaseComponent } from '../base-component/base-component';
import { ProductCardData, ProductSmallCardData } from '../product-card/product-card-display';
import { customElement, property } from 'lit/decorators.js';
import { emitRedeemEbookCodeEvent } from '../product-card/utils/product-card.analytics.util';
import { html, nothing, TemplateResult } from 'lit';
import { isRedeemableProduct } from '../product-card/utils/product-card.util';
import { REDEEM_BTN_TEXT } from './utils/my-bookshelf.util';
import { ariaLabelWithNewTab } from '../../common/utils/a11y-util';

@customElement('mhecomm-my-bookshelf-redeem-link')
export class MyBookshelfRedeemLink extends BaseComponent {
  @property({ type: Object })
  product?: ProductCardData | ProductSmallCardData;

  @property({ type: Boolean })
  isCreateCustomProduct = false;

  renderComp(): TemplateResult | typeof nothing {
    if (!this.product || !isRedeemableProduct(this.product)) {
      return nothing;
    }
    const redeemUrl = this.isCreateCustomProduct ? this.getCartRedeemUrl() : this.getRedeemUrl();

    return html`
      <p class="mb-0">
        <a 
          class="btn btn-link link-dark-underline p-0 fw-bold"
          href="${redeemUrl}"
          target="${this.isCreateCustomProduct ? '_blank' : '_self'}"
          rel="${this.isCreateCustomProduct ? 'noreferrer noopener' : ''}"
          aria-label="${this.isCreateCustomProduct ? ariaLabelWithNewTab(REDEEM_BTN_TEXT) : REDEEM_BTN_TEXT}"
          data-automation-id="redeem-ebook-code-link"
          @click=${(e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            this.redeemEbookCodeNow(this.isCreateCustomProduct);
          }}>
            ${REDEEM_BTN_TEXT}
        </a>
      </p>
    `;
  }

  private redeemEbookCodeNow(isCartRedirect: boolean): void {
    emitRedeemEbookCodeEvent({ element: this, product: this.product });
    if (isCartRedirect) {
      window.open(this.getCartRedeemUrl(), '_blank', 'noopener,noreferrer');
    } else {
      window.location.assign(this.getRedeemUrl());
    }
  }

  getCartRedeemUrl() {
    return environment().myBookShelfUrl + '/bookshelf/redeemcode';
  }

  getRedeemUrl(): string {
    return environment().myBookShelfUrl + '/sso/root?app=shop&flow=redeemcode';
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-my-bookshelf-redeem-link': MyBookshelfRedeemLink;
  }
}
